<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left" />
      </f7-nav-left>
      <f7-nav-title>叫號螢幕狀態</f7-nav-title>
    </f7-navbar>

    <template v-for="(monitor, index) in monitors">
      <div :key="`monitor-${index}`">
        <div style="text-align: right; margin: 10px;">{{ monitor.id }}</div>
        <f7-card>
          <f7-card-content>
            <f7-list>
              <f7-list-input ref="name" label="名稱" type="text" placeholder="螢幕代號" :value="monitor.name" @input="updateMonitorName({ id: monitor.id, name: $event.target.value })" @focus="onFocus($refs['name'][index])" clear-button />
              <f7-list-input label="字體大小" :input="false">
                <f7-range slot="input" :value="monitor.settings.fontSize" :min="20" :max="400" :step="10" :label="true" @range:changed="v => updateMonitorSettings({ id: monitor.id, settings: { fontSize: v }})" />
              </f7-list-input>
            </f7-list>
          </f7-card-content>
        </f7-card>
      </div>
    </template>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
    }
  },
  async created () {
    await this.getMonitors()
  },
  computed: {
    ...mapState('monitorModule', ['monitors'])
  },
  methods: {
    ...mapActions('monitorModule', ['getMonitors', 'updateMonitorSettings', 'updateMonitorName']),
    onFocus (component) {
      component.$el.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    }
  }
}
</script>
